import { Component, OnInit, AfterViewInit, OnDestroy, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { CclNavbarSecondaryService, CclSideNavItem, CclMessageService } from "certain-common-library";
import { SharedService } from "../../../../modules/shared/services/shared.service";
import { CatalogService } from "../../../../modules/shared/services/catalog.service";
import { SessionService } from "../../../../modules/shared/services/session-service";
import { LocalDataService } from "../../../../modules/shared/services/local-data.service";
import { Subscription } from "rxjs";
import { forkJoin } from "rxjs/observable/forkJoin";
import { DragScrollComponent } from "ngx-drag-scroll";
import * as moment from 'moment';
import 'moment-timezone';
import { DatePipe } from '@angular/common';

@Component({
    selector: "tab-section",
    templateUrl: "./tab-section.view.html",
    styleUrls: []
})
export class TabSectionView implements OnInit, AfterViewInit, OnDestroy {
    private subscription: Subscription;
    tabConfig: any;
    private tabData: any = {};
    private selectedTabData: any = "allDay";
    private filterConfig: any;

    standardFieldLabels: any = {};
    customFieldLabels: any = {};
    objIndex;

    @ViewChild("nav", { read: DragScrollComponent })
    ds: DragScrollComponent;

    constructor(
        private datePipe: DatePipe,
        private navSecondaryService: CclNavbarSecondaryService,
        public sharedService: SharedService,
        private router: Router,
        private messageService: CclMessageService,
        private sessionService: SessionService,
        private localDataService: LocalDataService
    ) {
        this.navSecondaryService.includeSave = false;
        this.subscription = this.messageService.getMessage().subscribe((message) => this.changeContext(message));
        if (this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG] != null) {
            this.filterConfig = JSON.parse(
                this.sharedService.configs[this.sharedService.configTypes.FILTER_CONFIG].config
            );
        }
    }

    ngOnInit() {
        if (this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG] != null) {
            this.tabConfig = JSON.parse(this.sharedService.configs[this.sharedService.configTypes.TAB_CONFIG].config);
        }
        if(!('selectTimezone' in this.filterConfig)) {
            this.filterConfig.selectTimezone = 'browser_timezone';
        }
        if (this.tabConfig.tabData == "sessionDays") {
            this.objIndex = this.filterConfig.selectedFields.find(element => element.field == 'sessionDate');
            if (this.filterConfig.hasOwnProperty("selectedDates")) {
                    this.tabData = [];
                    this.filterConfig.selectedDates.sort(function(x, y){
                        return x - y;
                    });
                    this.filterConfig.selectedDates.forEach((date) => {
                        this.tabData.push({
                            id: new Date(date),
                            label: new Date(date)
                        });
                    });
                
                    if(this.tabData != null) {
                        if(this.filterConfig.selectTimezone == 'browser_timezone') {
                            this.tabData = this.sharedService.filterSessionDateForBrowserTimezone;
                        } else {
                            if(this.tabData != null) {
                                this.tabData.forEach(element => {
                                    if(element.label) {
                                        element.label = moment(element.label).format(this.sharedService.dateFormat);
                                        element.id = element.label;
                                        element.label = this.datePipe.transform(element.label,this.tabConfig.dateFormat);
                                    } 
                                });
                            }
                        }
                    }
            } else {
                this.tabData = this.sharedService.sessionDays;
                if(this.objIndex == undefined && this.tabData.length > 0) {
                    if(this.filterConfig.selectTimezone != 'browser_timezone') {
                        this.tabData.forEach(element => {
                            if(element.label) {
                                element.label = moment(element.label).format(this.sharedService.dateFormat);
                                element.id = element.label;
                                element.label = this.datePipe.transform(element.label,this.tabConfig.dateFormat);
                            } 
                        });
                    } else {
                        this.tabData.forEach(element => {
                            if(element.label) {
                                element.label = moment(element.label).tz(this.sharedService.timezone).format(this.sharedService.dateFormat);
                                element.id = element.label;
                                element.label = this.datePipe.transform(element.label,this.tabConfig.dateFormat);
                            } 
                        });
                    }
                }
            }
        } else {
            let dateArray = [];
            let eventStartDate = this.sharedService.event.startDate;
            let eventEndDate = this.sharedService.event.endDate;
            let temp = this.sharedService.getDateArray(new Date(eventStartDate), new Date(eventEndDate));
            temp.forEach((date) => {
                dateArray.push({
                    id: date,
                    label: date
                });
            });
            this.tabData = dateArray;
        }
        let temp = [];
        this.tabData.forEach(element => {
            if(temp.findIndex(item => item.label === element.label) == -1) {
                temp.push(element);
            }
        });
        this.tabData = temp;
    }

    ngAfterViewInit(): void {}

    ngOnDestroy() {
        this.sharedService.unsubscribeHelper(this.subscription);
    }

    changeContext(message) {
        if (message.text == "clear-text-search-field") {
            this.selectedTabData = "allDay";
        } else if (message.text == "set-all-day") {
            this.selectedTabData = "allDay";
        } else if (message.text == 'change-timezone') {
            if(message?.data && message?.data?.sessionDate?.length>0) {
                this.tabData = message.data.sessionDate;
        }
    }
    }

    selectTab($event, id) {
        if (this.sharedService.generalListLoading) {
            return false;
        }
        this.selectedTabData = id;
        if(this.selectedTabData != 'allDay') {
            this.sharedService.tabChangedDate = this.datePipe.transform(this.selectedTabData, "yyyy-MM-dd");
        }

        this.messageService.sendMessage("changed-date", {
            selectTab: this.selectedTabData
        });
    }
    moveLeft() {
        this.ds.moveLeft();
    }

    moveRight() {
        this.ds.moveRight();
    }
}
